import { Base } from "./base";
import { getAccessToken } from "../utils/browserStorage";

export class WorkOrderTimeTrackingType extends Base {
  /**
   * @description List Work Order Time Tracking Type API function
   * @returns {Promise<Response>}
   */
  list(query) {
    let queryParam = new URLSearchParams(query).toString();
    const url = this._getFullURL("/cmms/work-order-time-tracking-type?" + queryParam);
    return this._secureFetch(url);
  }
  create(payload) {
    const url = this._getFullURL("/cmms/work-order-time-tracking-type");

    return fetch(url, this._generateRequestBody({ payload, method: "POST" }));
  }
  update(id, payload) {
    const url = this._getFullURL("/cmms/work-order-time-tracking-type/" + id);
    return fetch(url, this._generateRequestBody({ payload, method: "PUT" }));
  }

  delete = (id) => {
    const url = this._getFullURL(`/cmms/work-order-time-tracking-type/${id}`);
    return fetch(
      url,
      this._generateRequestBody({
        authentication: true,
        payload: null,
        method: "DELETE",
      })
    );
  };
}
